<breadcrumb-navigation [titles]="[{ key: 'HOME_ECATALOG' | translate, url: '/ecatalog'},{ key: 'COMPANY_SEARCH' | translate, url: ''}]" [needHome]="false"></breadcrumb-navigation>
<div class="mobile-vin-search drawer-body">
  <div class="search-input">
    <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input_mobile">
      <input 
        nz-input 
        type="text" 
        [(ngModel)]="codeSearchValue"
        [placeholder]="'SEARCH_BY_MANY' | translate" 
      />
      <ng-template #suffixTemplateInfo>
        <span nz-icon style="color: #595E62;" nzType="close" nzTheme="outline" [hidden]="codeSearchValue === ''" (click)="clearVehiclesVin()" ></span>
        <svg-icon [iconName]="'new/ui-ic-search-blue.svg'" (click)="queryVehiclesByCode()"></svg-icon>
      </ng-template>
    </nz-input-group>
  </div>
  <div class="search-storage">
    <div class="search-storage__title">
      <span>{{'SEARCH_HISTORY'|translate}}</span>
      <svg-icon [iconName]="'new/delete.svg'" (click)="handleClearSearchStorage()"></svg-icon>
    </div>
    <div class="search-storage__vin-list">
      <div class="search-storage__vin-item" *ngFor="let code of storageVinList;" (click)="handleSelectStorageItem(code)">{{ code }}</div>
    </div>
  </div>
</div>